/**
 * The addresses of the images of the charts. The server sends them ready to use with the entries of the chart sets
 * (imageUrl), the UI does not know where the images are. The address in the bucket of the video service is built here only
 * for a chart that has no entry in the chart sets of the room, and for a server that does not send the addresses.
 */
export class ChartImageUrls {

  /** @param videoAssetsUrl the address of the bucket of the video service */
  constructor(private readonly videoAssetsUrl: string) {}

  /** The address to show the image of the chart from: the one that the server sent with its entry. */
  imageUrl(chartId: string, entry?: { imageUrl?: string | null }): string {
    return entry?.imageUrl || this.videoUrl(chartId);
  }

  /** The address in the bucket of the video service, built for a chart without an entry. */
  videoUrl(chartId: string): string {
    return `${this.videoAssetsUrl}/default-charts/${chartId}/chart.png`;
  }
}
